import { render, staticRenderFns } from "./SettingsIntegrationEditor.vue?vue&type=template&id=5f4a1752&"
import script from "./SettingsIntegrationEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports